import { createReducer } from '@reduxjs/toolkit'
import { parsedQueryString } from 'hooks/useParsedQueryString'

import { typeInput } from './actions'
import { queryParametersToStakingState } from './hooks'

export interface UnstakingState {
  readonly typedValue: string
}

const initialState: UnstakingState = queryParametersToStakingState(parsedQueryString())

export default createReducer<UnstakingState>(initialState, (builder) =>
  builder.addCase(typeInput, (state, { payload: { typedValue } }) => {
    return {
      ...state,
      typedValue,
    }
  })
)
